import { Component } from '@angular/core';
import { UiComponentsModule } from '@mwe/ui/components';
import { TermsContentCardComponent } from './terms-content-card/terms-content-card.component';
import { TermsOfUseTitleComponent } from './terms-of-use-title/terms-of-use-title.component';

@Component({
  selector: 'ikp-terms-of-use',
  standalone: true,
  imports: [UiComponentsModule, TermsContentCardComponent, TermsOfUseTitleComponent],
  templateUrl: './terms-of-use.component.html',
})
export class TermsOfUseComponent {}
